import { render } from "./CallQueuesDetail.vue?vue&type=template&id=cefe7e4e"
import script from "./CallQueuesDetail.vue?vue&type=script&lang=js"
export * from "./CallQueuesDetail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__